import Component from '../../components/component/component';

import './volta-aero.scss';

export default class VoltaAero extends Component {
    static initSelector: string = '.js-volta-aero';

    iframeElement: JQuery;

    constructor(target: HTMLElement) {
        super(target);

        this.iframeElement = this.element.find('.volta-aero__iframe');

        this.init();
    }

    init(): void {
        window.addEventListener('message', this.messageHandler.bind(this));
    }

    messageHandler(event: MessageEvent): void {
        const src: string = this.iframeElement.attr('src');

        if (!src) {
            return;
        }

        const link: HTMLAnchorElement = document.createElement('a');

        link.href = src;

        if (event.origin !== `${link.protocol}//${link.host}`) {
            return;
        }

        if (event.data && event.data.type === 'volta-overview-resize') {
            this.iframeElement.css('height', `${event.data.height}px`);
        }
    }
}
